module.exports = __webpack_public_path__ + "img/87.8.TSS.510461fe.png";